import apiClient from '@/apiClient';
import { AxiosResponse } from 'axios';
import getTakeAwayTransformer from '@/api/transformers/dashboard/takeAwaysTransformer';
import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import {ProjectStats} from '@/interfaces/models/dashboard';

type DashboardSalesStatsResponse = {
  [key: string]: {
    products: any[];
    ingredients: any[];
  }
}

export default {
  fetchPlaces() {
    return apiClient.get('/dashboard', {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({ data }: AxiosResponse) => data);
  },
  fetchDailyStats(dateFrom: number, dateTo: number) {
    return apiClient.get(`/dashboard/daily/stats/${dateFrom}/${dateTo}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({ data }: AxiosResponse) => data);
  },
  fetchStats(dateFrom: number, dateTo: number): Promise<ProjectStats> {
    return apiClient.get(`/dashboard/stats/${dateFrom}/${dateTo}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({ data }: AxiosResponse<ProjectStats>) => data);
  },
  fetchStaffStats(selectedPlaceIds: string[], dateFrom: number, dateTo: number): Promise<ProjectStats> {
    return apiClient.get(`dashboard/staff/statistics?places=${selectedPlaceIds.join(',')}&dateFrom=${dateFrom}&dateTo=${dateTo}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({ data }: AxiosResponse<ProjectStats>) => data);
  },
  fetchOrders({ cancelToken, ...params }: any) {
    return apiClient.get(
      '/dashboard/order/list',
      {
        params,
        cancelToken,
        transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
        transformResponse: getTakeAwayTransformer()
      }
    )
      .then(({ data }: AxiosResponse) => data);
  },
  fetchDashboardSalesStats(timestampFrom: number, timestampTo: number): Promise<DashboardSalesStatsResponse> {
    return apiClient.get(`/dashboard/sales/list/${timestampFrom}/${timestampTo}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({ data }: AxiosResponse<DashboardSalesStatsResponse>) => data);
  }
};
